module.exports = __webpack_public_path__ + "img/skridsko_akare1.6a0a07d3.jpg";